<div class="ai-dropdown-wrapper">
    <!-- Gatilho -->
    <div
        #selection
        class="ai-dropdown__trigger"
        [ngStyle]="styleClasses()"
        [ngClass]="{
            'ai-is-disabled': disabled(),
            'ai-is-open': optionsVisible(),
            'ai-is-invalid':
                formControl.invalid &&
                (formControl.dirty || formControl.touched)
        }"
        role="combobox"
        [attr.aria-expanded]="optionsVisible()"
        aria-haspopup="listbox"
        (click)="changeVisibility()"
    >
        <span class="ai-dropdown__value">
            @if (selectedOption(); as opt) {
                <ng-container
                    [ngTemplateOutlet]="optionTemplate() ?? defaultValueTemplate"
                    [ngTemplateOutletContext]="{
                        $implicit: opt,
                        option: opt,
                        selected: true,
                        active: false
                    }"
                ></ng-container>
            } @else {
                <span class="ai-dropdown__placeholder">{{ defaultLabel() }}</span>
            }
        </span>

        <div class="ai-dropdown__indicators">
            @if (clearable() && selectedOption() && !disabled()) {
                <button
                    type="button"
                    class="ai-dropdown__clear"
                    aria-label="Limpar seleção"
                    (click)="clear($event)"
                >
                    <ai-icon [fontIcon]="'fa-solid fa-xmark'" />
                </button>
            }
            <!--
                Ícone de erro: sempre no DOM, exibido via CSS quando o host
                (`<ai-dropdown>`) recebe `ng-invalid` + `ng-touched`/`ng-dirty`.
            -->
            <ai-icon
                class="ai-dropdown__error-icon"
                [fontIcon]="'fa-solid fa-circle-exclamation'"
            />
            <ai-icon
                class="ai-dropdown__caret"
                [fontIcon]="'fa-solid fa-angle-down'"
            />
        </div>
    </div>

    <!-- Painel de opções -->
    @if (optionsVisible()) {
        <div
            #optionBox
            class="ai-dropdown__panel"
            role="listbox"
            [@dropdownFade]
            [style.top.px]="panelTop()"
            [style.left.px]="panelLeft()"
            [style.width.px]="panelWidth()"
            [style.maxHeight.px]="panelMaxHeight()"
        >
            @if (showSearch()) {
                <div class="ai-dropdown__search">
                    <ai-icon
                        class="ai-dropdown__search-icon"
                        [fontIcon]="'fa-solid fa-magnifying-glass'"
                    />
                    <input
                        type="text"
                        class="ai-dropdown__search-input"
                        [placeholder]="searchPlaceholder()"
                        [value]="searchTerm()"
                        (input)="onSearchInput($any($event.target).value)"
                        (click)="$event.stopPropagation()"
                    />
                </div>
            }

            <div class="ai-dropdown__scroll">
                @for (
                    option of filteredOptions();
                    track option.value;
                    let i = $index
                ) {
                    <div
                        class="ai-dropdown__option"
                        [id]="'ai-dd-opt-' + i"
                        role="option"
                        [attr.aria-selected]="isSelected(option)"
                        [attr.aria-disabled]="option.disabled || null"
                        [ngClass]="{
                            'ai-is-selected': isSelected(option),
                            'ai-is-active': i === activeIndex(),
                            'ai-is-disabled': option.disabled
                        }"
                        (click)="onSelectOption(option)"
                    >
                        <ng-container
                            [ngTemplateOutlet]="optionTemplate() ?? defaultOptionTemplate"
                            [ngTemplateOutletContext]="{
                                $implicit: option,
                                option: option,
                                selected: isSelected(option),
                                active: i === activeIndex()
                            }"
                        ></ng-container>
                        @if (isSelected(option)) {
                            <ai-icon
                                class="ai-dropdown__option-check"
                                [fontIcon]="'fa-solid fa-check'"
                            />
                        }
                    </div>
                }

                @if (filteredOptions().length === 0) {
                    <div class="ai-dropdown__empty">{{ emptyText() }}</div>
                }
            </div>
        </div>
    }
</div>

<!--
    Templates padrão (formato atual): ícone da opção + rótulo. Reproduzem o
    comportamento anterior à introdução de `[optionTemplate]`. O valor
    selecionado (gatilho) e as opções da lista usam classes distintas.
-->
<ng-template #defaultValueTemplate let-option>
    @if (option.icon || option.iconImage) {
        <ai-icon
            class="ai-dropdown__value-icon"
            [fontIcon]="option.icon"
            [imageIcon]="option.iconImage"
        />
    }
    <span class="ai-dropdown__value-label">{{ option.label }}</span>
</ng-template>

<ng-template #defaultOptionTemplate let-option>
    @if (option.icon || option.iconImage) {
        <ai-icon
            class="ai-dropdown__option-icon"
            [fontIcon]="option.icon"
            [imageIcon]="option.iconImage"
        />
    }
    <span class="ai-dropdown__option-label">{{ option.label }}</span>
</ng-template>
